import { AxiosInstance } from "axios";
import { Method, Resource } from "../Resource";

export type TokenRequest = {
  clientId?: string;
  referrer?: string;
  appId?: string;
};

export type Token = {
  token: string;
};

export class Tokens extends Resource<TokenRequest> {
  constructor(axiosInstance: AxiosInstance) {
    super("tokens", axiosInstance);
  }

  public async generate(
    clientId: string,
    tokenRequest: TokenRequest
  ): Promise<Token> {
    const { token } = await this.request({
      method: Method.POST,
      body: { clientId, ...tokenRequest }
    });

    return token;
  }
}
